import React from 'react';
import { FaBullseye, FaEye, FaGem } from 'react-icons/fa';
import ScrollReveal from '../components/ScrollReveal';
import { useLanguage } from '../contexts/LanguageContext';

type SectionProps = {
    icon: React.ReactNode;
    title: string;
    description: string;
};

const Section: React.FC<SectionProps> = ({ icon, title, description }) => (
    <div className="flex flex-col items-center text-center max-w-xs mx-auto">
        <div className="text-[#29519f] text-6xl">{icon}</div>
        <h2 className="text-2xl font-semibold text-gray-800 mt-4">{title}</h2>
        <p className="text-gray-600 mt-2">{description}</p>
    </div>
);
const Objectives = () => {
    const { tString } = useLanguage();
    
    return (
        <section
            className="w-screen flex items-center justify-center  px-16 py-12"
            style={{
                backgroundColor: '#f7f8f9',
                backgroundImage: `
                    radial-gradient(ellipse 80% 60% at center, transparent 0%, #f7f8f9 80%),
                    url('/images/pattern.png')
                `,
                backgroundSize: 'auto',
                backgroundRepeat: 'repeat',
            }}
        >
            <div className="w-screen flex items-center justify-center py-16 ">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 px-4">
                    <ScrollReveal direction="up" delay={0.2} duration={0.8}>
                        <Section
                            icon={<FaBullseye />}
                            title={tString('objectives.mission.title')}
                            description={tString('objectives.mission.description')}
                        />
                    </ScrollReveal>
                    <ScrollReveal direction="up" delay={0.4} duration={0.8}>
                        <Section
                            icon={<FaEye />}
                            title={tString('objectives.vision.title')}
                            description={tString('objectives.vision.description')}
                        />
                    </ScrollReveal>
                    <ScrollReveal direction="up" delay={0.6} duration={0.8}>
                        <Section
                            icon={<FaGem />}
                            title={tString('objectives.values.title')}
                            description={tString('objectives.values.description')}
                        />
                    </ScrollReveal>
                </div>
            </div>
        </section>
    );
};

export default Objectives;